module.exports = __webpack_public_path__ + "static/media/mr-clean-primary.4fc4fa43.svg";